const input = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

/**
 * Set value of function
 * @param {Event} event
 * @param {Function} setter
 */
export const handleInput = (event, setter) => setter(event.target.value);

/**
 * Checks length
 * @param {Event} event 
 * @param {String} variable 
 * @param {Number} checkLength 
 */
export const handleKeyPress = (event, stringToCheck, checkLength) =>
  stringToCheck?.length === checkLength &&
  event.key in input &&
  event.preventDefault();
